import { router } from "@inertiajs/react";
import type { ReactElement } from "react";
import { useState } from "react";

import { Progress, ProgressIndicator, ProgressTrack } from "@/components/ui/progress";
import { useMountEffect } from "@/hooks/use-mount-effect";

const PAGE_VISIT_PROGRESS_DELAY_MS = 250;

export const PageVisitProgress = (): ReactElement | null => {
  const [isVisible, setIsVisible] = useState(false);

  useMountEffect(() => {
    let visibilityTimer: ReturnType<typeof setTimeout> | null = null;

    const cancelVisibilityTimer = (): void => {
      if (visibilityTimer === null) {
        return;
      }

      clearTimeout(visibilityTimer);
      visibilityTimer = null;
    };

    const removeStartListener = router.on("start", () => {
      cancelVisibilityTimer();
      visibilityTimer = setTimeout(() => {
        setIsVisible(true);
        visibilityTimer = null;
      }, PAGE_VISIT_PROGRESS_DELAY_MS);
    });
    const removeFinishListener = router.on("finish", () => {
      cancelVisibilityTimer();
      setIsVisible(false);
    });

    return () => {
      cancelVisibilityTimer();
      removeStartListener();
      removeFinishListener();
    };
  });

  if (!isVisible) {
    return null;
  }

  return (
    <Progress
      aria-label="Loading page"
      aria-valuetext="Loading page"
      className="pointer-events-none fixed inset-x-0 top-0 z-50 gap-0"
      value={null}
    >
      <ProgressTrack className="h-1 rounded-none bg-transparent">
        <ProgressIndicator className="h-full w-1/3 motion-safe:animate-pulse" />
      </ProgressTrack>
    </Progress>
  );
};
